import { queryOptions } from "@tanstack/react-query";
import { getNotifications } from "./notifications-api";

export const notificationQueries = {
  all: (userId: string) => ["notifications", userId] as const,
  list: (userId: string) =>
    queryOptions({
      queryKey: [...notificationQueries.all(userId), "list"] as const,
      queryFn: () => getNotifications(userId),
      staleTime: 30_000,
      // Override the global false default: refetch when the user returns to the
      // tab so that events missed while it was backgrounded are caught.
      refetchOnWindowFocus: true,
    }),
};
